import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "small-arrow-blue_ba1dc82784eaa1062c21eef1f98ff86e",
  "use": "small-arrow-blue_ba1dc82784eaa1062c21eef1f98ff86e-usage",
  "viewBox": "0 0 6 8",
  "content": "<symbol viewBox=\"0 0 6 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"small-arrow-blue_ba1dc82784eaa1062c21eef1f98ff86e\">\n<path d=\"M1.66668 0L0.726685 0.94L3.78002 4L0.726685 7.06L1.66668 8L5.66668 4L1.66668 0Z\" fill=\"#1671ED\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol